import styled from "styled-components";

export const Line = styled.div`
    width: 100%;
    border-bottom: 1px solid #333;
    margin: 20px 0;
`;
